<template>
  <v-layout column height="600" class="">    
    <v-divider></v-divider>  
    <mbs-page-tab 
        :items="OFFICE_LINKS"/> 
    <v-divider></v-divider>  
    <v-divider></v-divider>  
    <v-divider></v-divider>  
    <v-layout v-if="false"> 
        <mbs-page-spinner :show="true" />  
    </v-layout>     
    <v-container v-else grid-list-lg>  
        <v-layout row wrap class="px-4 py-5"> 
            <!-- //others -->
            <v-flex xs6 sm4 lg3 >
                <v-hover >
                    <template v-slot="{ hover  }">
                        <v-card  hover @click.prevent ="ADD_STOCK_LEVEL()"
                            rounded="xl"  :color="'secondary -1'"  
                            height="100%" min-height="230" class="pa-2">   
                            <v-layout column fill-height class="ma-0">
                                <v-spacer></v-spacer>
                                <v-responsive  aspect-ratio="1.8"  >
                                    <v-layout column fill-height align-center justify-center>
                                        <v-icon size="30" color="white">mdi-plus-box-multiple</v-icon>
                                        <div class="font-weight-bold white--text text--darken-1 not-f7 text-center">Create Stock Level</div>
                                    </v-layout>
                                </v-responsive>    
                            </v-layout>
                        </v-card> 
                    </template>
                </v-hover>
            </v-flex>
            <v-flex xs6 sm4 lg3 v-for="(link, index) in MY_LINKS" :key="index">
                <v-hover>
                    <template v-slot="{ hover  }">
                        <v-card   
                            @click="MBS.actions.go(link.link)"
                            :elevation="hover ?12:''" class="b2"
                            hover  rounded="xl"
                            height="100%">  
                            <v-responsive  aspect-ratio="1.5"  >
                                <v-card rounded="xl" height="100%" :color="link.image_background_color" >
                                    <v-layout class="ma-0" align-center justify-center fill-height > 
                                        <v-card rounded="xl" color="transparent" height="100%" :width="link.image_size?link.image_size+'%':'50%'" tile flat>
                                            <v-menu    offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <div>
                                                        <v-layout  class="py-5" > 
                                                            <v-spacer></v-spacer> 
                                                            <v-btn 
                                                                dark
                                                                icon
                                                                v-on="on" >
                                                                <v-icon>mdi-dots-vertical</v-icon>
                                                            </v-btn> 
                                                        </v-layout> 
                                                    </div>
                                                </template> 
                                                <v-list v-if="true"> 
                                                    <v-list-item @click="VIEW_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>mdi-eye</v-icon></v-list-item-action>
                                                        <v-list-item-title>View Account</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="EDIT_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>edit</v-icon></v-list-item-action>
                                                        <v-list-item-title>Edit Account</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="ARCHIVE_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>delete</v-icon></v-list-item-action>
                                                        <v-list-item-title>Archive Account</v-list-item-title>
                                                    </v-list-item>
                                                    <!-- <v-list-item @click="DELETE_ACCOUNT(link)">
                                                        <v-list-item-action><v-icon>delete</v-icon></v-list-item-action>
                                                        <v-list-item-title>Delete Account</v-list-item-title>
                                                    </v-list-item> -->
                                                     
                                                </v-list> 
                                            </v-menu>  
                                            <v-layout   align-center justify-center column> 
                                                
                                                <v-icon class="mt-3" size="50" color="grey darken-">mdi-ballot-recount-outline</v-icon>
                                            </v-layout>
                                            <v-img  v-if="false"  
                                                :src="link.image?link.image:MBS.data.noImg" >  
                                                <template v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"
                                                        ></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>  
                                            
                                        </v-card>
                                    </v-layout>  
                                </v-card>
                            </v-responsive>
                            <!-- <v-card-title >
                                <div>Stock Level</div>
                                <v-layout class="ma-0" >
                                    <div class="headline" >{{link.name}}</div> 
                                </v-layout>
                            </v-card-title>  -->
                            <v-spacer></v-spacer> 
                            <v-card-text class="py-2"> 
                                <small class="secondary--text font-weight-bold">
                                    {{link.stock_level_type_name}} 
                                    <span v-if="link?.stock_outlet">( {{ link?.stock_outlet_name}} )</span>
                                </small> 
                                <div class="font-weight-bold not-f5" >{{link.name}}</div>
                            </v-card-text>
                        </v-card> 
                    </template>
                </v-hover>
            </v-flex>
        </v-layout>  z
        <div>
            <mbs-item-manager
                :show="false" 
                :name_items="NAME_ITEMS"
                :name_item="NAME_ITEM"
                :value_items="VALUE_ITEMS"
                :value_item="VALUE_ITEM"
                :field_items="DATA.FIELDS.stock_level"   
                :path_item="StockLevelsPath"  
                :select_items="DataSource"  
                @ADDED="ADDED"
                @EDITED="EDITED"
                @DELETED="DELETED"
                />
                <!-- :select_items="SelectInputFieldsItems"    -->
        </div>
    </v-container>  
  </v-layout> 
</template>

<script>
import DATA from '../../../../../plugins/DATA' 
import {mapState} from "vuex"
import { mdiFormatListGroupPlus } from '@mdi/js'; 
let PAGE_NAME = DATA.ITEMS.STOCK_LEVELS.values 
    export default {
        name:PAGE_NAME, 
        data() {
        return {
            PAGE_SHOW:false, 
            NAME_ITEMS:DATA.ITEMS.STOCK_LEVELS.names,
            NAME_ITEM:DATA.ITEMS.STOCK_LEVELS.name,
            VALUE_ITEMS:DATA.ITEMS.STOCK_LEVELS.values,
            VALUE_ITEM:DATA.ITEMS.STOCK_LEVELS.value,  
            DATA:DATA, 
            format_list_group_plus: mdiFormatListGroupPlus,
        }
        },
        mounted() {
            this.MBS.actions.header({
                show:true,
                type:'subToolbar', 
                
            })
            this.MBS.actions.subToolbar({
                show:true,
                height:70,
                flat:false,
                color:'primary',
                textColor:'white', 
                side:'right'
            }) 
            this.FEEDBACKS(500) 
        },
        computed: {
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                JoinedItemDepartments: state=> state.join[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()], 
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                StockLevelTypes: state=> state.app["STOCK_LEVEL_TYPES"], 
            }),  
            ItemDepartmentsData(){ 
                let ItemDepartments = this.JoinedItemDepartments?this.JoinedItemDepartments:this.ItemDepartments 
                return ItemDepartments
            },
            StockOutletsData(){ 
                let StockOutlets = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets 
                return StockOutlets
            },
            StockLevels(){ 
                const settings = this.CompanySettings
                const stock_levels_ob = settings?.STOCK_LEVELS
                const stock_levels = stock_levels_ob?Object.entries(stock_levels_ob).map(([key,value])=>({...value,key})):null
                const joined = this.MBS.actions.JOIN_STOCK_LEVELS(stock_levels)
                console.log(settings,'sett............');
                console.log(stock_levels,'stock_levels............');
                console.log(joined,'joined............');
                
                return joined?joined:stock_levels
            },
            ItemsData(){ 
                let Items = this.Items
                let JoinedItems = this.JoinedItems
                let CalculatedItems = this.CalculatedItems 
                if (JoinedItems) {
                    return JoinedItems
                } 
                return Items
            },
            InventoryItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })  
                return filtered
            },
            DataSource(){
                const Departments = this.ItemDepartmentsData
                const StockOutlets = this.StockOutletsData
                const StockLevelTypes = this.StockLevelTypes

                return {
                    Departments,
                    StockOutlets,
                    StockLevelTypes
                }
            },
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
             
            /////////
            MY_LINKS(){  
                let accounts = this.StockLevels 
                if(!accounts){return null}
                let allLinks = []
                accounts.forEach(element => {
                    allLinks.push({
                        ...element,
                        name:element.name,
                        link:this.MBS.actions.COMPANY_LINK("/stock/stock-levels/"+element.code,true),
                        icon:'link', 
                        image_background_color:'primary lighten-2',
                        image_size:'80',
                        
                    })
                });  
                return allLinks
            },
            OFFICE_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("manage",2,true) 
                return thisLinks
            },
            StockLevelsPath(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_levels,true) 
                return path
            }, 
        },
        methods: { 
            clicked(){},
            ADD_STOCK_LEVEL(input){
                try {    
                    this.MBS.events.$emit("ITEM_ACTION",{
                        NAME_ITEM:DATA.ITEMS.STOCK_LEVELS.name,
                        action:"add_item",
                        input:{name:input}
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_STOCK_LEVEL',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            async SYNC_STOCK_LEVELS(stock_level){
                try {   
                    const items = this.InventoryItems  
                    const res = await this.MBS.actions.SYNC_STOCK_LEVELS({stock_level,items})
                    console.log(res,'res..........++');
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SYNC_STOCK_LEVELS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            



            ADDED(res){
                try {  
                    const stock_level = res?.data
                    this.SYNC_STOCK_LEVELS(stock_level) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADDED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            EDITED(res){
                try { 
                    console.log(res,'--------------edited');
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'EDITED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            DELETED(res){
                try {
                    let dr = this.ItemsDownloadRequest 
                    let dr_on = dr?.on
                    if(!dr_on){
                        this.RELOAD_ITEMS() 
                    }
                    console.log(res,'DELETED....................');
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DELETED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },

            EDIT_ACCOUNT(item){
                try {     
                    this.MBS.events.$emit("ITEM_ACTION",{
                        NAME_ITEM:this.NAME_ITEM,
                        action:"edit_item",
                        item:item
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'EDIT_ACCOUNT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ARCHIVE_ACCOUNT(item){
                try {    
                    this.MBS.events.$emit("ITEM_ACTION",{
                        NAME_ITEM:this.NAME_ITEM,
                        action:"archive_item",
                        item:item
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ARCHIVE_ACCOUNT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            DELETE_ACCOUNT(item){
                try {    
                    this.MBS.events.$emit("ITEM_ACTION",{
                        NAME_ITEM:this.NAME_ITEM,
                        action:"delete_item",
                        item:item
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DELETE_ACCOUNT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            VIEW_ACCOUNT(item){
                try {    
                    this.MBS.actions.go(item.link)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'VIEW_ACCOUNT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            //LOAD
            EXIT_PAGE(){
                if (!this.us) {
                    this.MBS.actions.go("/")
                }else{
                    this.PAGE_SHOW = true
                }
            },
            FEEDBACKS(time=400){ 
                setTimeout(()=>{
                    let us = this.us 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses 

                    //CHECK USER STATE 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        }) 

                        if (logging) {
                            this.PAGE_SHOW =false
                        }else{
                            this.EXIT_PAGE()
                        }     
                    }else{
                       this.EXIT_PAGE()
                    }

                     
                },time)
            }
        },
        watch: { 
            us(v){
                this.FEEDBACKS()
            },
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            } 
        },
  }
</script>
 
